import {  useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';

import { gql } from '../../generated';
import { DashboardBalanceInHeaderOutput } from '../../generated/graphql';

type UseDashboardBalanceResponse = {
  dashboardBalanceInHeader?: DashboardBalanceInHeaderOutput[];
};

const GET_DASHBOARD_BALANCE = gql(/* GraphQL */ `
  query dashboardBalanceInHeader {
    dashboardBalanceInHeader {
      balance
      currency_id
    }
  }
`);

export const useDashboardBalance = () => {
  const [getBalance, { data, loading, refetch }] = useLazyQuery(GET_DASHBOARD_BALANCE);

  useEffect(() => {
    // Обновляем баланс раз в минуту
    const interval = setInterval(() => {
      refetch();
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [refetch]);

  return {
    loading,
    balance: data?.dashboardBalanceInHeader,
    refetch,
    getBalance,
  };
};
